import React from "react";
import { BlobServiceClient } from "@azure/storage-blob";

const storageAccount = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT;
const sasToken = process.env.REACT_APP_AZURE_SAS_TOKEN;

export const blobServiceClientConnection = new BlobServiceClient(
  `https://${storageAccount}.blob.core.windows.net?${sasToken}`,
);

export const downloadBlobFile = async (
  containerName,
  blobName,
  originalName,
) => {
  try {
    const containerClient =
      blobServiceClientConnection.getContainerClient(containerName);
    const blobClient = containerClient.getBlobClient(blobName);
    const downloadBlockBlobResponse = await blobClient.download(0);
    return {
      status: "success",
      data: await downloadBlockBlobResponse.blobBody,
    };
  } catch (err) {
    return { status: "error", err };
  }
};

export const uploadBlobToContainer = async (
  containerName: String,
  blobName: String,
  file: File,
) => {
  try {
    const containerClient =
      blobServiceClientConnection.getContainerClient(containerName);

    const blobClient = containerClient.getBlockBlobClient(blobName);
    const options = { blobHTTPHeaders: { blobContentType: file.type } };

    const uploadBlobResponse = await blobClient.uploadData(file);
    return { status: "success", requestId: uploadBlobResponse.requestId };
  } catch (err) {
    return { status: "error", err };
  }
};
